export const IS_TOUCH_DEVICE = 'IS_TOUCH_DEVICE';

export const setAsTouchDevice = () => {
  return { type: IS_TOUCH_DEVICE };
};
